import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { updateConfig } from "../../../../../store/slices/Reassign/reassignSlice";
import {
  addToRecheckList,
  addToReissueList,
  getCommittedList,
  getRecheckCommittedList,
  reAssignMember,
  reAssignRecheckMember,
} from "../../api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  useGetProcessListDataQuery,
  useGetUserListDataQuery,
} from "../../../../../store/queries/Orders";
import { getAgentData } from "../../../Order/api";
import { useEffect, useState } from "react";
import * as Yup from "yup";

const useReassignModel = ({ refetch, activeTab }) => {
  const dispatch = useDispatch();
  const { data: processListData } = useGetProcessListDataQuery();
  const { data: userListData } = useGetUserListDataQuery();
  const [committedList, setCommitList] = useState([]);
  const [certificateList, setCertificateList] = useState([]);
  const {selectedId} = useSelector((state) => state.reassign);

  const initialValues = {
    item_details_id: [],
    process_slug: "",
    employ_id: "",
    process_id: "",
    committed_id: "",
  };
  const validation = Yup.object({
    employ_id: Yup.string().required("*Required"),
    committed_id: Yup.string().required("*Required"),
    item_details_id: Yup.array().min(1, "*Select one").required("*Required"),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: validation,
    onSubmit: async (values) => {
      const params = {
        process_slug: values?.process_slug ?? "",
        employ_id: values?.employ_id ?? "",
        item_details_id: values?.item_details_id ?? [],
      };
      try {
        let response;
        if (activeTab === "orders") {
          response = await reAssignMember(params);
        } else {
          response = await reAssignRecheckMember(params);
        }
        if (response?.data?.status_code === 200) {
          toast.success(`Reassigned successfully`);
          setCertificateList([]);
          setCommitList([]);
          handleCancel();
          refetch();
        } else {
          toast.error(response?.message);
          setCertificateList([]);
          setCommitList([]);
          handleCancel();
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("Something went wrong");
      }
    },
  });

  const getFieldError = (fieldName) => {
    if (formik?.touched[fieldName] && formik?.errors[fieldName]) {
      return formik?.errors[fieldName];
    }
    return "";
  };

  const handleCancel = () => {
    dispatch(
      updateConfig((state) => {
        state.showReassignModal = false;
      })
    );
  };
  const processObj = processListData?.data?.filter(
    (item) => item?._id === formik?.values?.process_id
  );

  const getCommitList = (value) => {
    let param = {
      slug: value?.slug,
      process_id: value?._id,
      stock_receipt_id: selectedId
    };
    if(activeTab === "recheck") {
      getRecheckCommittedList(param).then((response) => {
        if (response?.data?.status_code === 200) {
          setCommitList(response?.data?.data);
        } else {
          toast.error(response?.message);
        }
      });
    }
    else {
      getCommittedList(param).then((response) => {
        if (response?.data?.status_code === 200) {
          setCommitList(response?.data?.data);
        } else {
          toast.error(response?.message);
        }
      });
    }
    
  };

  const committedObj = committedList?.filter(
    (item) => item?.user_id === formik?.values?.committed_id
  );
  const userObj = userListData?.data?.staff_list?.filter(
    (item) => item?.id === formik?.values?.employ_id
  );

  const isAllSelected =
    certificateList?.length > 0 &&
    formik.values.item_details_id?.length === certificateList?.length;

  const handleItemChange = (value, actionMeta) => {
    if (actionMeta?.option?.item_id === "*") {
      if (isAllSelected) {
        formik.setFieldValue("item_details_id", []);
      } else {
        formik.setFieldValue(
          "item_details_id",
          certificateList?.map((v) => v?.item_id) || []
        );
      }
    } else {
      formik.setFieldValue(
        "item_details_id",
        value?.filter((v) => v?.item_id !== "*")?.map((v) => v?.item_id) || []
      );
    }
  };
  return {
    formik,
    processData: processListData?.data,
    userList: userListData?.data?.staff_list,
    processObj,
    getFieldError,
    handleCancel,
    getCommitList,
    committedList: committedList,
    setCommitList,
    committedObj,
    certificateList,
    setCertificateList,
    userObj,
    handleItemChange,
    isAllSelected,
  };
};

export default useReassignModel;
